/**
 * @file       Auth mixin, used by the whole auth module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapActions } from "vuex";

/**
 * Auth mixin.
 *
 * @type  {Object}
 */
const authMixin = {
  methods: {
    ...mapActions("auth", {
      login: "login"
    }),

    /**
     * Called on login.
     * 
     * @param  {Object}  payload  The login payload.
     */
    onLogin (payload) {
      this.login(payload)
        .then(res => {
          // Get the user and its role
          const user = res.data.data.find(u => u);
          const role = user ? user.role : "";

          // If the request contains a redirect
          if (this.$route.query.redirect) {
            this.$router.push({
              path: this.$route.query.redirect
            });
          } else {
            // Show a welcome message
            this.$root.$bvToast.toast("Bienvenue à Dlibr", {
              title: "Connexion réussie"
            });

            // Redirect depending on the user's role
            let redirect = "";
            switch (role) {
              // Redirect to the users list in the admin dashboard
              case "admin": {
                redirect = { name: "admin.users" };
                break;
              }

              // Redirect to the deliberations list in the teacher dashboard
              case "teacher": {
                redirect = {
                  name: "teacher.own.deliberations",
                  params: { id: user.id }
                };
                break;
              }

              // Redirect to the deliberation list in the student dashboard
              case "student": {
                redirect = {
                  name: "student.own.deliberations",
                  params: { id: user.id }
                };
                break;
              }

              // Redirect to the deliberation list in the student dashboard
              case "guest": {
                redirect = {
                  name: "student.deliberations",
                  params: { id: user.id }
                };
                break;
              }

              // Redirect to home by default
              default: {
                redirect = {
                  name: "home"
                };
                break;
              }
            }

            this.$router.push(redirect);
          }
        })
        .catch(err => {
          const message =
            err.response.data.message == "Nickname has been taken"
              ? "Ce pseudonyme est déjà utilisé, veuillez en choisir un autre."
              : "Valeur de connexion invalide";

          // Display an error message
          this.$root.$bvToast.toast(message, {
            title: "Erreur",
            variant: "danger"
          });
        });
    }
  }
};

export { authMixin };
